import React, { useEffect } from 'react'
import { Toolbar } from 'components/Toolbar'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useRequiredParam } from 'utils/misc'
import {
    invalidateDataRoomDocumentsQuery,
    invalidateProjectQuery,
    useProjectQuery,
    useTeamPermissionsForResourceQuery,
} from 'utils/queries'
import { route } from 'utils/routes'
import { ProjectInnerLayout } from '../components/ProjectPageLayout'
import { NavTabs } from '../components/NavTabs'
import { ProjectDataRoomDocuments } from '../components/ProjectDataRoomDocuments'
import DataRoomDocumentUploader from '../components/DataRoomDocumentUploader'
import { Separator } from '../components/Separator'
import { useUpdateProjectFocusedDocument } from '../state/ProjectFocusedDocument.state'
import { ReadOnly } from '../components/ReadOnly'

const Root = styled.div`
    display: grid;
    gap: 48px;
    padding: 40px 40px 96px;
`

function ProjectDataRoomShowPage() {
    const projectId = useRequiredParam('id')
    const { t } = useTranslation()
    const { data: project } = useProjectQuery({ projectId })

    const updateFocusedDocument = useUpdateProjectFocusedDocument()

    const { data: permission, isFetching: teamPermissionIsLoading } =
        useTeamPermissionsForResourceQuery({
            projectId,
        })

    useEffect(() => {
        return () => {
            updateFocusedDocument(null)
        }
    }, [])

    return (
        <ProjectInnerLayout
            projectId={projectId}
            toolbars={
                <Toolbar>
                    <Toolbar $grow>
                        <NavTabs>
                            <NavLink to={route('project', projectId)} end>
                                <small>Overview</small>
                            </NavLink>
                            <NavLink to={route('projectDataRoom', projectId)}>
                                <small>{t('project.dataRoom')}</small>
                            </NavLink>
                        </NavTabs>
                    </Toolbar>
                </Toolbar>
            }
        >
            {!teamPermissionIsLoading && permission === 'Viewer' && (
                <ReadOnly />
            )}
            <Root>
                {project && project.dataRoom.id && (
                    <DataRoomDocumentUploader
                        dataRoomId={project.dataRoom.id}
                        onDocumentAdded={() => {
                            invalidateProjectQuery(project.id)
                            invalidateDataRoomDocumentsQuery(project.dataRoomId)
                        }}
                        disabled={
                            teamPermissionIsLoading || permission === 'Viewer'
                        }
                    />
                )}

                {project && project.dataRoom._count.documents > 0 && (
                    <>
                        <Separator />
                        <ProjectDataRoomDocuments
                            projectId={projectId}
                            tableTitle="All documents"
                        />
                    </>
                )}
            </Root>
        </ProjectInnerLayout>
    )
}

export default ProjectDataRoomShowPage
